import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Icon, Checkbox, Divider } from 'antd';

const ChooseGroup = ({ country, data, selectedNums, handleSelectedNum, index, handleChoose }) => {
  const [checkedList, setCheckedList] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [checkedNum, setCheckedNum] = useState(0);
  const [indeterminate, setIndeterminate] = useState(false);
  const [isShow, setShow] = useState(false);

  useEffect(() => {
    // 如果有已经sign up的landlord，需要设置checkedNum，indeterminate，isShow,setAll

    const defaultSelectedArr = data?.filter(item => item.selected === true);

    if (defaultSelectedArr?.length) {
      setCheckedNum(defaultSelectedArr?.length);
      setIndeterminate(defaultSelectedArr?.length < data?.length ? true : false);
      setCheckAll(defaultSelectedArr?.length === data?.length ? true : false);
      setShow(true);
    } else {
      setCheckedNum(0);
      setCheckAll(false);
    }
    setCheckedList(data);
  }, [data]);
  const chooseAll = () => {
    const newCheckedList = checkedList?.map(item => ({ ...item, selected: true }));

    setCheckedList(newCheckedList);
    setCheckedNum(newCheckedList?.length);
    setIndeterminate(!!newCheckedList.length && newCheckedList.length < data?.length);
    setIndeterminate(false);
    handleSelectedNum(selectedNums + newCheckedList?.length);
    handleChoose(index, newCheckedList);
  };

  const notChooseAll = () => {
    const newCheckedList = checkedList?.map(item => ({ ...item, selected: false }));
    setCheckedList(newCheckedList);
    setIndeterminate(false);

    setCheckedNum(0);
    handleSelectedNum(selectedNums - newCheckedList?.length);
    handleChoose(index, newCheckedList);
  };

  const chooseSingle = (e, id) => {
    let newCheckedNum = checkedNum;
    let newSelectedNums = selectedNums;
    const newCheckedList = checkedList?.map(item => {
      if (item?.id === id) {
        newCheckedNum = e?.target?.checked ? newCheckedNum + 1 : newCheckedNum - 1;
        newSelectedNums = e?.target?.checked ? newSelectedNums + 1 : newSelectedNums - 1;
        return { ...item, selected: e?.target?.checked ? true : false };
      } else {
        return { ...item };
      }
    });
    setCheckedList(newCheckedList);
    setCheckedNum(newCheckedNum);
    setCheckAll(newCheckedNum === data?.length);
    setIndeterminate(!!newCheckedNum && newCheckedNum < data?.length);
    handleSelectedNum(newSelectedNums);
    handleChoose(index, newCheckedList);
  };

  return (
    <>
      <div className="booking__checkCountry-box">
        <Icon
          type="caret-up"
          className={classNames('booking__modal-icon', { 'booking__modal-iconRotate': !isShow })}
          onClick={() => {
            setShow(!isShow);
          }}
        />
        <Checkbox
          onChange={e => {
            if (e.target.checked) {
              chooseAll();
            } else {
              notChooseAll();
            }
            setCheckAll(e.target.checked);
          }}
          // style={{ lineHeight: '22px' }}
          checked={checkAll}
          indeterminate={indeterminate}
        >
          {country} <Divider type="vertical" className="booking__divider" />
          <span className="booking__checkCountry-number">
            {checkedList?.length} Landlords,{checkedNum} Selected
          </span>
        </Checkbox>
      </div>
      <If condition={isShow}>
        <div>
          <If condition={!!checkedList?.length}>
            <For each="item" of={checkedList} index="index">
              <div className="booking__checkBox">
                <Checkbox
                  value={item?.id}
                  key={item?.id}
                  checked={item?.selected}
                  onChange={e => {
                    chooseSingle(e, item?.id);
                  }}
                >
                  {item?.name}
                </Checkbox>
              </div>
            </For>
          </If>
        </div>
      </If>
    </>
  );
};
export default ChooseGroup;
